import React from 'react';
import { Buffer } from 'buffer';
window.Buffer = window.Buffer || Buffer;
import ReactDOM from 'react-dom/client';
import App from './App';
import Api from "./utils/Api";
import {I18nextProvider} from 'react-i18next';
import i18next from './utils/i18next.js';

const api = new Api();
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

//  Translations laden. Danach App starten.
api.request('GetI18n', null, (res) => {
    if (res) {
        for (let langCode in res) {
            let translations = res[langCode];

            i18next.addResources(langCode, 'translations', translations);
        }

        //  React laden.
        root.render(
            <I18nextProvider i18n={i18next}>
                <App />
            </I18nextProvider>
        );
    }
}, null);